import { LITERAL_TYPES } from '@/utils/mapperConfigDraft';
export default {
  name: 'MapperLiteralField',
  props: {
    value: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    typeLabel: {
      type: String,
      required: false,
      default: ''
    },
    allowJson: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    dataTest: {
      type: String,
      required: false,
      default: 'mapper-literal'
    }
  },
  computed: {
    typeItems() {
      return LITERAL_TYPES.filter(type => this.allowJson || type !== 'json').map(type => ({
        text: this.$i18n_t(`Bridges.mapperBuilder.literal.types.${type}`),
        value: type
      }));
    },
    booleanItems() {
      return [{
        text: this.$i18n_t('Bridges.mapperBuilder.literal.true'),
        value: 'true'
      }, {
        text: this.$i18n_t('Bridges.mapperBuilder.literal.false'),
        value: 'false'
      }];
    },
    jsonError() {
      if (this.value.type !== 'json' || !this.value.text.trim()) {
        return [];
      }
      try {
        JSON.parse(this.value.text);
        return [];
      } catch (_) {
        return [this.$i18n_t('Bridges.mapperBuilder.literal.invalidJson')];
      }
    }
  },
  methods: {
    setType(type) {
      this.value.type = type;
      if (type === 'boolean' && this.value.text !== 'true' && this.value.text !== 'false') {
        this.value.text = 'false';
      }
      this.$emit('change');
    },
    setText(text) {
      this.value.text = text === null || text === undefined ? '' : String(text);
      this.$emit('change');
    }
  }
};